/**
 * @name ROLES
 * @description AskCody roles
 */
export const ROLES = {
  OWNER: 'ROLE_OWNER',
  USER: 'ROLE_USER',
};
